const en = {
  // Layout
  "admin.siteName": "Al-Siyahiah",
  "admin.role.admin": "Admin",
  "admin.role.writer": "Writer",
  "admin.nav.dashboard": "Dashboard",
  "admin.nav.articles": "Manage Articles",
  "admin.nav.newArticle": "New Article",
  "admin.nav.videos": "Manage Videos",
  "admin.nav.adPackages": "Ad Packages",
  "admin.nav.adPlacements": "Ad Placements",
  "admin.nav.adRequests": "Ad Requests",
  "admin.nav.aboutPage": "About Page",
  "admin.nav.gccGuide": "Gulf Guide",
  "admin.nav.users": "Manage Users",
  "admin.nav.categories": "Categories",
  "admin.nav.settings": "Settings",
  "admin.nav.infographics": "Infographics",
  "admin.nav.opinion": "Opinion Articles",
  "admin.nav.analytics": "Detailed Analytics",
  "admin.nav.socialLinks": "Social Media Accounts",
  "admin.nav.contactMessages": "Reader Messages",
  "admin.nav.ogPreview": "Share Preview Test",
  "admin.nav.newspaperPdf": "Newspaper PDF",
  "admin.nav.mainSite": "Main Website",
  "admin.nav.logout": "Sign Out",
  "admin.logout.title": "Sign Out",
  "admin.logout.confirm": "Are you sure you want to sign out?",
  "admin.logout.confirmBtn": "Confirm Sign Out",
  "admin.logout.cancel": "Cancel",

  // Article Form
  "article.form.newTitle": "New Article",
  "article.form.editTitle": "Edit Article",
  "article.form.cancel": "Cancel",
  "article.form.saving": "Saving...",
  "article.form.saved": "Saved!",
  "article.form.publish": "Publish Article",
  "article.form.saveChanges": "Save Changes",
  "article.form.langLabel": "Article Language",
  "article.form.langAr": "عربي",
  "article.form.langEn": "English",

  // Article fields
  "article.field.titleAr": "Article Title (Arabic)",
  "article.field.titleEn": "Article Title (English)",
  "article.field.titlePlaceholderAr": "أدخل العنوان الرئيسي للمقال...",
  "article.field.titlePlaceholderEn": "Enter the main article title...",
  "article.field.excerptAr": "Article Excerpt (Arabic)",
  "article.field.excerptEn": "Article Excerpt (English)",
  "article.field.excerptPlaceholderAr": "مقدمة قصيرة تظهر في بطاقة الخبر...",
  "article.field.excerptPlaceholderEn": "Short intro shown in the news card...",
  "article.field.contentLabel": "Full Article Content",
  "article.field.contentPlaceholderAr": "اكتب نص المقال الكامل هنا...",
  "article.field.contentPlaceholderEn": "Write the full article content here...",
  "article.field.chars": "chars",

  // Image
  "article.image.label": "Cover Image",
  "article.image.change": "Change Image",
  "article.image.delete": "Remove Image",
  "article.image.dropTitle": "Click to upload or drag & drop",
  "article.image.dropSub": "PNG, JPG, WEBP — max 5 MB",
  "article.image.choose": "Choose Image",

  // Sidebar
  "article.sidebar.publishSettings": "Publish Settings",
  "article.sidebar.category": "Category",
  "article.sidebar.author": "Author",
  "article.sidebar.authorPlaceholder": "Author name",
  "article.sidebar.tags": "Tags (comma separated)",
  "article.sidebar.tagsPlaceholder": "e.g. Dubai, Tourism, 2026",
  "article.sidebar.source": "News Source",
  "article.sidebar.sourceName": "Source Name",
  "article.sidebar.sourceNamePlaceholder": "e.g. Reuters, AP...",
  "article.sidebar.sourceUrl": "Source URL",
  "article.sidebar.featured": "Homepage",
  "article.sidebar.featuredToggle": "Feature on homepage",
  "article.sidebar.featuredDesc": "Appears in featured news section",
  "article.sidebar.preview": "Card Preview",
  "article.sidebar.previewTitle": "Article Title",
  "article.sidebar.previewExcerpt": "Article excerpt...",
  "article.sidebar.previewAuthor": "Author",
  "article.sidebar.featured.badge": "Featured",
};

export default en;
